import React, { FC, PropsWithChildren } from 'react';

import classNames from 'classnames';
import './card.scss';

type CardProps = PropsWithChildren<{
  className?: string;
  title: string;
  required?: boolean;
  disabled?: boolean;
}>;

const Card: FC<CardProps> = ({
  className,
  title,
  children,
  required = false,
  disabled = false,
}) => {
  return (
    <div
      className={classNames(
        'polytech-card',
        { 'polytech-card--required': required },
        { 'polytech-card--disabled': disabled },
        className
      )}
    >
      <span className="polytech-card__header">{title}</span>
      {children}
    </div>
  );
};

export default Card;
